(() => {
  'use strict';

  const KEY = 'mxpRepairDraftV2';
  const FAULT_PATH = '/pages/reparation-iphone-panne';
  const QUOTE_PATH = '/pages/reparation-iphone-devis';
  const MODEL_PATH = '/pages/reparation-iphone';
  const DIAGNOSTICS = new Set(["ne s'allume plus"]);
  const norm = v => String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\u2019\u2018]/g, "'").toLowerCase().replace(/\s+/g, ' ').trim();
  const pathname = location.pathname.replace(/\/$/, '');
  const isFault = pathname === FAULT_PATH;
  const isQuote = pathname === QUOTE_PATH;
  const isRepairRoute = pathname === MODEL_PATH || isFault || isQuote;
  if (!isRepairRoute || window.__mxpRepairPriceAvailabilityV1) return;
  window.__mxpRepairPriceAvailabilityV1 = true;

  const readDraft = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; }
    catch (_) { return {}; }
  };
  const writeDraft = patch => {
    const next = Object.assign({}, readDraft(), patch || {}, { updatedAt: Date.now() });
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (_) {}
    return next;
  };
  const preview = () => {
    try { return new URLSearchParams(location.search).get('preview_theme_id') || ''; }
    catch (_) { return ''; }
  };
  const go = path => {
    const u = new URL(path, location.origin);
    const p = preview();
    if (p) u.searchParams.set('preview_theme_id', p);
    location.assign(u.pathname + u.search);
  };

  function ensureStyle() {
    if (document.getElementById('mxp-price-availability-style')) return;
    const s = document.createElement('style');
    s.id = 'mxp-price-availability-style';
    s.textContent = `
      html.mxp-price-gate .mxp-panel{visibility:hidden!important}
      .mxp-repair[data-mxp-price-state="loading"]{pointer-events:none!important}
      .mxp-repair[data-mxp-price-state="unavailable"]{
        opacity:.48!important;
        filter:grayscale(.45);
        cursor:not-allowed!important;
        pointer-events:auto!important;
        background:#f3f4f5!important;
        border-color:#dfe2e5!important;
        box-shadow:none!important;
        transform:none!important;
      }
      .mxp-repair[data-mxp-price-state="unavailable"]:hover{
        transform:none!important;
        box-shadow:none!important;
        border-color:#dfe2e5!important;
      }
      .mxp-repair[data-mxp-price-state="unavailable"] .mxp-faultprice,
      .mxp-repair[data-mxp-price-state="unavailable"] .mxp-faultprice span{
        color:#6f767e!important;
      }
      .mxp-repair[data-mxp-price-state="unavailable"] .mxp-badge{
        opacity:.72!important;
      }
    `;
    document.head.appendChild(s);
  }

  if (isFault || isQuote) document.documentElement.classList.add('mxp-price-gate');
  ensureStyle();

  const root = document.querySelector('[data-mxp-repair]');
  if (!root) {
    document.documentElement.classList.remove('mxp-price-gate');
    return;
  }

  function primeDraftFields() {
    if (!isFault && !isQuote) return;
    const draft = readDraft();
    const modelField = root.querySelector('[data-field="model"]');
    const faultField = root.querySelector('[data-field="fault"]');
    const model = String(draft.model || '').trim();
    const fault = String(draft.fault || '').trim();
    if (modelField && model && modelField.value !== model) modelField.value = model;
    if (isQuote && faultField && fault && faultField.value !== fault) faultField.value = fault;
  }

  primeDraftFields();

  let navigating = false;
  let scheduled = false;

  const setText = (el, value) => {
    if (el && el.textContent !== value) el.textContent = value;
  };
  const findFault = value => [...root.querySelectorAll('.mxp-repair[data-fault]')].find(card => norm(card.dataset.fault) === norm(value));
  const isDiagnostic = card => DIAGNOSTICS.has(norm(card && card.dataset ? card.dataset.fault : ''));

  function markLoading(card) {
    if (!card) return;
    if (card.dataset.mxpPriceState !== 'loading') card.dataset.mxpPriceState = 'loading';
    if (card.dataset.mxpPricingResolved) delete card.dataset.mxpPricingResolved;
    card.setAttribute('aria-disabled', 'true');
  }

  function markAvailable(card, cents) {
    if (!card) return;
    const box = card.querySelector('.mxp-faultprice');
    const label = box && box.querySelector('span');
    if (card.dataset.mxpPriceState !== 'available') card.dataset.mxpPriceState = 'available';
    if (card.dataset.mxpPricingResolved !== '1') card.dataset.mxpPricingResolved = '1';
    card.removeAttribute('aria-disabled');
    card.removeAttribute('title');
    if (Number.isFinite(cents) && cents > 0) card.dataset.price = String(cents / 100);
    if (label) setText(label, isDiagnostic(card) ? 'DIAGNOSTIC' : 'PRIX');
  }

  function markUnavailable(card) {
    if (!card) return;
    const box = card.querySelector('.mxp-faultprice');
    const label = box && box.querySelector('span');
    const native = box && box.querySelector('[data-mxp-native-price]');
    if (card.dataset.mxpPriceState !== 'unavailable') card.dataset.mxpPriceState = 'unavailable';
    if (card.dataset.mxpPricingResolved !== '1') card.dataset.mxpPricingResolved = '1';
    if (card.dataset.price !== '0') card.dataset.price = '0';
    card.setAttribute('aria-disabled', 'true');
    card.setAttribute('title', 'Cette réparation n’est pas disponible pour ce modèle.');
    if (label) setText(label, 'INDISPONIBLE');
    if (native) setText(native, 'Non disponible');
  }

  function inspectCard(card) {
    const box = card.querySelector('.mxp-faultprice');
    const native = box && box.querySelector('[data-mxp-native-price]');
    if (!native) {
      markLoading(card);
      return 'loading';
    }
    const rawCents = String(native.dataset.mxpNativePrice || '').trim();
    if (rawCents !== '') {
      const cents = Number(rawCents);
      if (Number.isFinite(cents)) {
        if (cents <= 0) {
          markUnavailable(card);
          return 'unavailable';
        }
        markAvailable(card, cents);
        return 'available';
      }
    }
    const text = norm(native.textContent);
    if (text.includes('indisponible') || text.includes('non disponible')) {
      markUnavailable(card);
      return 'unavailable';
    }
    markLoading(card);
    return 'loading';
  }

  function inspectAll() {
    primeDraftFields();
    const cards = [...root.querySelectorAll('.mxp-repair[data-fault]')];
    cards.forEach(inspectCard);
    return cards;
  }

  function quoteReady(card) {
    if (!card || card.dataset.mxpPriceState !== 'available') return false;
    const finalStep = root.querySelector('[data-step="3"]:not([hidden])');
    const raw = Number(root.dataset.mxpNativePriceCents || 0);
    const result = root.querySelector('[data-result-price]');
    const text = result ? norm(result.textContent) : '';
    return !!finalStep && raw > 0 && !!text && text !== '...' && text !== '…' && text !== '-';
  }

  function evaluateGate() {
    const cards = inspectAll();
    if (isFault) {
      const active = root.querySelector('[data-step="1"]:not([hidden])');
      const done = cards.length > 0 && cards.every(card => card.dataset.mxpPricingResolved === '1');
      if (active && done) document.documentElement.classList.remove('mxp-price-gate');
      return;
    }
    if (isQuote) {
      const draft = readDraft();
      const selected = draft.fault ? findFault(draft.fault) : null;
      if (!selected) return;
      if (selected.dataset.mxpPriceState === 'unavailable') {
        if (!navigating) {
          navigating = true;
          writeDraft({ fault: '', price: '', shipping: '' });
          go(FAULT_PATH);
        }
        return;
      }
      if (quoteReady(selected)) document.documentElement.classList.remove('mxp-price-gate');
      return;
    }
    document.documentElement.classList.remove('mxp-price-gate');
  }

  function queueEvaluate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      evaluateGate();
    });
  }

  document.addEventListener('click', e => {
    const card = e.target.closest && e.target.closest('.mxp-repair[data-fault]');
    if (!card || !root.contains(card) || e.isTrusted === false) return;
    inspectCard(card);
    if (card.dataset.mxpPriceState !== 'available') {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', e => {
    const form = e.target;
    if (!form || !root.contains(form)) return;
    const faultField = root.querySelector('[data-field="fault"]');
    const draft = readDraft();
    const selectedFault = (faultField && faultField.value) || draft.fault || '';
    const card = selectedFault ? findFault(selectedFault) : null;
    if (!card) return;
    inspectCard(card);
    if (card.dataset.mxpPriceState !== 'available' || !(Number(card.dataset.price) > 0)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.alert('Cette réparation est momentanément indisponible pour ce modèle.');
      if (!navigating && isQuote) {
        navigating = true;
        writeDraft({ fault: '', price: '', shipping: '' });
        go(FAULT_PATH);
      }
    }
  }, true);

  new MutationObserver(queueEvaluate).observe(root, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['data-price', 'data-mxp-native-price', 'hidden']
  });

  queueEvaluate();
  setTimeout(() => {
    if (!isFault || !document.documentElement.classList.contains('mxp-price-gate')) return;
    const cards = [...root.querySelectorAll('.mxp-repair[data-fault]')];
    cards.forEach(card => {
      if (card.dataset.mxpPricingResolved !== '1') markUnavailable(card);
    });
    queueEvaluate();
  }, 10000);
})();